export default function parseURIComponent(p: string): string {
  return decodeURIComponent(p.replace(/\+/g, ' '))
}
